<a class="text-theme-primary underline" href="#" (mousedown)="$event.stopPropagation()" (click)="$event.preventDefault(); onClick()">
  {{ value }}
</a>
